var map = {
	"./music-instructions.json": 4557,
	"./music-library-intro2024.json": 4558,
	"./music-library-launch2024.json": 4559,
	"./music-progression.json": 4560,
	"./startSourcesAdvanced.json": 4561,
	"./startSourcesSimple.json": 4562,
	"./startSourcesSimple2.json": 4563,
	"./startSourcesTracks.json": 4564
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4335;